module.exports = __webpack_public_path__ + "img/global-education.1491c984.png";